import React from "react";
import { Helmet } from "react-helmet";

/**
 * SEO Component - Add meta tags, Open Graph, and Twitter cards to any page
 * 
 * @param {string} title - Page title (will append " | The New Calendar")
 * @param {string} description - Page description for search engines
 * @param {string} image - URL for social sharing image (og:image)
 * @param {string} url - Canonical URL for the page
 * @param {string} type - Open Graph type (default: "website")
 */
const SEO = ({
  title = "The New Calendar",
  description = "The New Calendar uses math, science, and logic to divide time evenly and efficiently. Discover the 5th season and take control of your time.",
  image = "https://res.cloudinary.com/dqy3fktlv/image/upload/v1700665978/EKJClknXYAgIzI2_pk6dy9.jpg",
  url = "https://thenewcalendar.com",
  type = "website",
}) => {
  const fullTitle = title === "The New Calendar" 
    ? title 
    : `${title} | The New Calendar`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="The New Calendar" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@thenewcalendar" />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="Tom Sherman" />
      <meta name="keywords" content="calendar, new calendar, 5 seasons, five seasons, calendar reform, time management, perpetual calendar" />
    </Helmet>
  );
};

export default SEO;
